import React = require('react')

export let status_thank_you_renderer = (input: string) => {
  return (
    <div>
      <div className='text--styled form__message'>
        <p dangerouslySetInnerHTML={{ __html: input }} />
      </div>
    </div>
  )
}

export let status_sending_renderer = () => {
  return <p className='form__alert alert--info'> Versturen... </p>
}

export let status_error_renderer = () => {
  return <p className='form__alert alert--error'> Er is iets misgegaan, probeer het later nog eens... </p>
}
